module.exports = __webpack_public_path__ + "img/case-ct_revoltcapsule_side.0cc1e94.png";